import { render, staticRenderFns } from "./transToOrder.vue?vue&type=template&id=ef29ab1e&scoped=true&"
import script from "./transToOrder.vue?vue&type=script&lang=js&"
export * from "./transToOrder.vue?vue&type=script&lang=js&"
import style0 from "./transToOrder.vue?vue&type=style&index=0&id=ef29ab1e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef29ab1e",
  null
  
)

component.options.__file = "transToOrder.vue"
export default component.exports